export enum LDIdentityType {
  ID = 'ID',
  FARM = 'FARM',
  EMAIL = 'EMAIL',
}
